"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseBarChartOptions = void 0;
/**
 * getBaseBarChartOptions
 *
 * @return a base object with the options configuration for ChartJS component
 */
var getBaseBarChartOptions = function () { return ({
    tooltips: {
        enabled: false,
    },
    legend: {
        display: false,
    },
    scales: {
        yAxes: [
            {
                display: true,
                ticks: {
                    fontSize: 12,
                    beginAtZero: true,
                    stepSize: 50,
                    suggestedMax: 100,
                },
            },
        ],
        xAxes: [
            {
                gridLines: {
                    display: false,
                },
                display: true,
                ticks: {
                    fontSize: 12,
                    beginAtZero: true,
                },
            },
        ],
    },
}); };
exports.getBaseBarChartOptions = getBaseBarChartOptions;
exports.default = exports.getBaseBarChartOptions;
